export default __webpack_public_path__ + "static/media/alejandra.4b554ed1.png";